import React, { useEffect, useRef } from 'react';

import { mount, unmount } from 'redom';

import NativeTextMarkButtons from './';

function NativeTextMarkButtonsReactWrapper(props) {

  const wrapperMainReference = useRef(null);
  const nativeTextMarkButtonsReference = useRef(null);

  useEffect(function onLoad() {

    const container = wrapperMainReference.current;

    const nativeTextMarkButtons = new NativeTextMarkButtons(props);

    nativeTextMarkButtonsReference.current = nativeTextMarkButtons;

    mount(container, nativeTextMarkButtonsReference.current);

    return function onUnload() {

      unmount(container, nativeTextMarkButtons);

    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(function onPropsChange() {

    nativeTextMarkButtonsReference.current.update(props);

  }, [props]);

  function renderMain() {

    const mainAttributes = {
      className: 'text-mark-buttons-native-react-wrapper-main',
      ref: wrapperMainReference
    };

    return <div {...mainAttributes}>
    
    </div>;

  }

  return renderMain();

}

export default NativeTextMarkButtonsReactWrapper;